/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_user = {
    readonly tradeFirm?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_tradeFirm">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsGridSeller_user" | "PdpRespSimilarItemsFooter_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarBlurbs_user" | "PdpRespShippingReturns_user" | "PdpRespBuyerAssuranceBox_user" | "PdpRespSidebarContact_user" | "PdpRespHeroCarousel_user" | "PdpRespIconBubblesWrapper_user" | "PdpRespDealerDetails_user" | "PdpRespSidebarSellerInfo_user" | "PdpSharedPromoCode_user" | "PdpSharedTradeRewardsBenefitCardLoader_user" | "PdpRespSwatchSelector_user" | "SharedRecentlyViewedItems_user" | "SuspectedTradeUserLoader_user" | "PdpSharedDescriptionAdditionalOptions_user" | "PdpSharedShippingDetails_user" | "PdpSharedBuyerProtectionBox_user" | "PdpRespSimilarItemsLanding_user">;
    readonly " $refType": "PdpRespContainer_user";
};
export type PdpRespContainer_user$data = PdpRespContainer_user;
export type PdpRespContainer_user$key = {
    readonly " $data"?: PdpRespContainer_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradeRewardsBenefitCardLoader_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingDetails_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBuyerProtectionBox_user",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tradeFirm",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmType",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedTradePointsEarnedMessage_tradeFirm",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_user",
      "args": null
    }
  ]
};
(node as any).hash = 'd7716ce2a349ed9def31261068007439';
export default node;
